<template>
  <div class="card-container">
    <div class="card-inner" ref="inner">
      <div class="card-front">
        <div
          class="logo-container d-flex align-items-center justify-content-center"
        >
          <img v-if="!isDark" :src="front.cards[index].image_dark" alt />
          <img v-if="isDark" :src="front.cards[index].image" />
        </div>
        <h4 class="gold-text card-headline">{{ front.cards[index].amount }}</h4>
        <p class="card-description">{{ front.cards[index].description }}</p>
        <p class="card-role">{{ front.cards[index].role }}</p>
      </div>
      <div class="card-back">
        <div
          class="logo-container d-flex align-items-center justify-content-center"
        >
          <img v-if="!isDark" :src="back.cards[index].image_dark" alt />
          <img v-if="isDark" :src="back.cards[index].image" />
        </div>
        <h4 class="gold-text card-headline">{{ back.cards[index].amount }}</h4>
        <p class="white-text card-description">
          {{ back.cards[index].description }}
        </p>
        <p class="card-role">{{ back.cards[index].role }}</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    front: Object,
    back: Object,
    index: String,
    isDark: Boolean
  }
};
</script>

<style lang="scss" scoped>
img {
  max-height: 100%;
  max-width: 100%;
  @media screen and (max-width: 768px) {
    max-height: 75px;
  }
}
.card-role {
  font-style: italic;
  text-transform: uppercase;
  font-size: 0.75rem;
}
h4 {
  font-size: 1.75rem;
  @media screen and (max-width: 1200px) {
    font-size: 1.5rem;
  }
  @media screen and (max-width: 990px) {
    font-size: 1.25rem;
  }
}
</style>
